import Ajv from 'ajv';

const ajv = new Ajv();

export const schema = {
  type: 'object',
  properties: {
    topic: {
      type: 'string',
      pattern: 'to/classroom/(.+)/robot_status',
    },
    payload: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        status: { type: 'number' },
        battery: { type: 'number' },
      },
      required: ['id', 'status', 'battery'],
    },
  },
  required: ['topic', 'payload'],
  additionalProperties: true,
};

const schemaCheck = ajv.compile(schema);

export const validator = schemaCheck;
